var _ellipse, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgSpaceTemplateWorkspace = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 34,
    viewBox: "0 0 56 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.22213,
    cy: 6.4763,
    rx: 6.22213,
    ry: 6.4763,
    transform: "matrix(-1 0 -2.13528e-06 1 56.001 21.0474)",
    fill: "#FF3D00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5566 7.99999C43.5566 3.58172 39.9749 0 35.5566 0H8.00173C3.58345 0 0.00172422 3.58172 0.00171479 8L0.00170574 12.2384C0.00169631 16.6567 3.58341 20.2384 8.00169 20.2384H43.5566L43.5566 7.99999Z",
    fill: "#FF3D00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4453 10.9284C12.4453 9.81065 13.3514 8.90454 14.4692 8.90454H29.8656C30.9834 8.90454 31.8895 9.81065 31.8895 10.9284C31.8895 12.0461 30.9834 12.9522 29.8656 12.9522H14.4691C13.3514 12.9522 12.4453 12.0461 12.4453 10.9284Z",
    fill: "white",
    fillOpacity: 0.4
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgSpaceTemplateWorkspace);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/space-template-workspace.0a4a552963628941ba5db0794d2036c1.svg";